document.addEventListener('DOMContentLoaded', () => {
  // Only enable hover behavior on devices with a mouse (not touch)
  if (!window.matchMedia('(pointer: fine)').matches) return;

  document.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details.mega-menu');
    const summary = menu.querySelector('summary');
    if (!details || !summary) return;

    let closeTimeout;

    menu.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    menu.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 150); // small delay so moving to the dropdown doesn't close it
    });
  });
});